import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

function PasswordlessLogin({ onClose }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [linkSent, setLinkSent] = useState(false);
  const [error, setError] = useState('');
  
  const { sendMagicLink, magicLinkEmail } = useAuth();

  const handleSendLink = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }
    
    try {
      setError('');
      setLoading(true);
      await sendMagicLink(email);
      setLinkSent(true);
    } catch (error) {
      setError(error.message || 'Failed to send magic link');
    } finally {
      setLoading(false);
    }
  };

  const handleRetry = () => {
    localStorage.removeItem('magicLinkEmail');
    setLinkSent(false);
    setEmail('');
    setError('');
  };
  
  return (
    <div className="passwordless-login">
      <h2>Magic Link Login</h2>
      
      {error && <div className="auth-error">{error}</div>}
      
      {linkSent || magicLinkEmail ? (
        <div className="magic-link-sent">
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <div style={{ fontSize: '48px', marginBottom: '10px' }}>📧</div>
            <h3>Check your email!</h3>
            <p>
              We sent a magic link to <strong>{email || magicLinkEmail}</strong>
            </p>
            <p style={{ color: '#666', fontSize: '14px' }}>
              Click the link in your email to sign in instantly. The link will expire in 1 hour.
            </p>
          </div>
          
          <div style={{ marginTop: '20px' }}>
            <button onClick={onClose} className="auth-button" style={{ marginRight: '10px' }}>
              Done
            </button>
            <button onClick={handleRetry} className="text-button">
              Use different email
            </button>
          </div>
          
          <div style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px', fontSize: '12px', color: '#666' }}>
            <strong>Didn't receive it?</strong>
            <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
              <li>Check your spam/junk folder</li>
              <li>Make sure you entered the correct email</li>
              <li>Wait a few minutes for delivery</li>
            </ul>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSendLink}>
          <div className="form-group">
            <label htmlFor="magic-email">Email Address</label>
            <input
              type="email"
              id="magic-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              disabled={loading}
              autoComplete="email"
            />
          </div>
          
          <button 
            type="submit" 
            className="auth-button" 
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Magic Link'}
          </button>
          
          <div className="magic-link-info">
            <p style={{ fontSize: '14px', color: '#666', marginTop: '15px' }}>
              ✨ <strong>No password needed!</strong><br/>
              We'll email you a secure link that signs you in instantly.
            </p>
          </div>
        </form>
      )}
    </div>
  );
}

export default PasswordlessLogin;